import { atom } from "recoil";

export const payInvoice = atom({
  key: "pay_invoice",
  default: null,
});
